@if (isFooterVisible) {
  <div class="topfan-footer-host" [ngStyle]="footerHostStyle">
    <app-footer-layout
      [data]="footerData"
      [showDefaultTopFanLogo]="true"
    ></app-footer-layout>
  </div>
}
